import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://teyjgpkqulojyllutpet.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'your_anon_key_here'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
})

// Admin-specific database types
export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          email: string
          display_name: string | null
          role: 'buyer' | 'provider' | 'admin'
          created_at: string
          updated_at: string
        }
      }
      projects: {
        Row: {
          id: string
          name: string
          country: string
          project_type: string
          verifier: string
          vintage_year: number
          status: 'pending' | 'approved' | 'rejected'
          provider_id: string
          created_at: string
        }
      }
      orders: {
        Row: {
          id: string
          user_id: string
          project_id: string
          side: 'buy' | 'sell'
          quantity_tons: number
          price_per_ton: number
          status: 'open' | 'filled' | 'partially_filled' | 'cancelled'
          created_at: string
        }
      }
      trades: {
        Row: {
          id: string
          buy_order_id: string
          sell_order_id: string
          project_id: string
          quantity_tons: number
          price_per_ton: number
          buyer_fee: number
          seller_fee: number
          executed_at: string
        }
      }
    }
  }
}
